<div class="sidebar-wrapper">

  <!-- Mobile Overlay -->
  <div
    *ngIf="mobileOpen"
    class="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm lg:hidden"
    (click)="closeMobile()"
  ></div>

  <!-- Sidebar -->
  <aside
    class="sidebar-aside fixed top-0 left-0 z-50 flex flex-col h-screen
           border-r border-[var(--color-border)]
           shadow-[0_10px_40px_rgba(1,50,55,0.06)]
           transition-all duration-300 overflow-hidden
           lg:relative lg:z-auto"
    [class.w-72]="!collapsed"
    [class.w-20]="collapsed"
    [class.-translate-x-full]="!mobileOpen && isMobile"
    [class.translate-x-0]="mobileOpen || !isMobile"
  >

    <!-- Header -->
    <div
      class="relative flex items-center h-20 px-5
             border-b border-[var(--color-border)]
             flex-shrink-0 z-10"
      [class.justify-between]="!collapsed"
      [class.justify-center]="collapsed"
    >

      <!-- Brand -->
      <div *ngIf="!collapsed" class="flex items-center gap-3 min-w-0">
        <div
          class="relative w-11 h-11 rounded-2xl
                 bg-[var(--color-secondary)]
                 flex items-center justify-center
                 shadow-[0_12px_30px_rgba(1,50,55,0.22)]
                 flex-shrink-0"
        >
          <div class="absolute inset-[1px] rounded-2xl border border-white/10"></div>
          <img src="./icon.png" alt="Chipo Logo" class="w-5 h-5 object-contain" />
        </div>
        <div class="min-w-0">
          <h1 class="text-[16px] font-bold tracking-tight text-[var(--color-secondary)]">Chipo</h1>
          <p class="text-xs truncate text-[var(--color-muted-foreground)]">Progress Looks Good</p>
        </div>
      </div>

      <!-- Collapsed Logo -->
      <div
        *ngIf="collapsed"
        class="w-11 h-11 rounded-2xl bg-[var(--color-secondary)]
               flex items-center justify-center
               shadow-[0_12px_30px_rgba(1,50,55,0.22)]"
      >
        <img src="./icon.png" alt="Chipo Logo" class="w-5 h-5 object-contain" />
      </div>

      <!-- Toggle (desktop) -->
      <button
        *ngIf="!collapsed"
        (click)="toggleSidebar()"
        class="w-9 h-9 rounded-xl flex items-center justify-center
               text-[var(--color-muted-foreground)]
               hover:text-[var(--color-secondary)]
               hover:bg-[var(--color-primary-light)]
               transition-all duration-200 lg:flex hidden cursor-pointer"
        aria-label="Collapse sidebar"
      >
        <i class="bi bi-layout-sidebar-inset text-base"></i>
      </button>

      <!-- Close on mobile -->
      <button
        *ngIf="!collapsed"
        (click)="closeMobile()"
        class="w-9 h-9 rounded-xl flex items-center justify-center
               text-[var(--color-muted-foreground)]
               hover:text-[var(--color-secondary)]
               hover:bg-[var(--color-primary-light)]
               transition-all duration-200 lg:hidden flex cursor-pointer"
        aria-label="Close menu"
      >
        <i class="bi bi-x text-lg"></i>
      </button>

    </div>

    <!-- Expand (collapsed desktop) -->
    <div *ngIf="collapsed" class="relative flex justify-center pt-4 z-10">
      <button
        (click)="toggleSidebar()"
        class="w-10 h-10 rounded-xl flex items-center justify-center
               text-[var(--color-muted-foreground)]
               hover:text-[var(--color-secondary)]
               hover:bg-[var(--color-primary-light)]
               transition-all duration-200 cursor-pointer"
        aria-label="Expand sidebar"
      >
        <i class="bi bi-layout-sidebar text-base"></i>
      </button>
    </div>

    <!-- Navigation -->
    <nav class="relative flex-1 overflow-y-auto px-3 py-5 space-y-1 z-10">
      <ng-container *ngFor="let item of navItems">

        <!-- Group -->
        <ng-container *ngIf="item.children; else singleItem">
          <button
            (click)="toggleGroup(item.label)"
            class="group w-full flex items-center gap-3
                   px-3 py-3 rounded-2xl
                   transition-all duration-200 cursor-pointer"
            [class.bg-[var(--color-primary-light)]]="isGroupActive(item)"
            [class.text-[var(--color-secondary)]]="isGroupActive(item) || expandedGroup === item.label"
            [class.text-[var(--color-muted-foreground)]]="!isGroupActive(item) && expandedGroup !== item.label"
            [class.hover:bg-[var(--color-primary-light)]]="!isGroupActive(item)"
            [title]="collapsed ? item.label : ''"
          >
            <div
              class="sidebar-nav-icon w-9 h-9 rounded-xl flex items-center justify-center
                     flex-shrink-0 transition-all duration-200"
              [class.bg-white]="isGroupActive(item)"
              [class.shadow-sm]="isGroupActive(item)"
            >
              <i [class]="'bi ' + item.icon + ' text-sm'"></i>
            </div>
            <span *ngIf="!collapsed" class="flex-1 text-left truncate text-sm font-semibold">
              {{ item.label }}
            </span>
            <i
              *ngIf="!collapsed"
              class="bi text-xs transition-transform duration-200"
              [class.bi-chevron-down]="expandedGroup !== item.label"
              [class.bi-chevron-up]="expandedGroup === item.label"
            ></i>
          </button>

          <!-- Children -->
          <div
            *ngIf="!collapsed && expandedGroup === item.label"
            class="ml-5 mt-1 mb-2 pl-5
                   border-l border-[var(--color-border)]
                   flex flex-col gap-1"
          >
            <button
              *ngFor="let child of item.children"
              (click)="navigate(child.route!)"
              class="group w-full flex items-center gap-3
                     px-3 py-2.5 rounded-xl
                     text-sm font-medium transition-all duration-200 cursor-pointer"
              [class.sidebar-nav-child--active]="activeRoute === child.route"
              [class.text-[var(--color-muted-foreground)]]="activeRoute !== child.route"
              [class.hover:bg-[var(--color-primary-light)]]="activeRoute !== child.route"
              [class.hover:text-[var(--color-secondary)]]="activeRoute !== child.route"
            >
              <i [class]="'bi ' + child.icon + ' text-sm flex-shrink-0'"></i>
              <span class="truncate">{{ child.label }}</span>
            </button>
          </div>

        </ng-container>

        <!-- Single -->
        <ng-template #singleItem>
          <button
            (click)="navigate(item.route!)"
            class="group w-full flex items-center gap-3
                   px-3 py-3 rounded-2xl
                   text-sm font-semibold transition-all duration-200 cursor-pointer"
            [class.sidebar-nav-item--active]="activeRoute === item.route"
            [class.text-[var(--color-muted-foreground)]]="activeRoute !== item.route"
            [class.hover:bg-[var(--color-primary-light)]]="activeRoute !== item.route"
            [class.hover:text-[var(--color-secondary)]]="activeRoute !== item.route"
            [title]="collapsed ? item.label : ''"
          >
            <div
              class="sidebar-nav-icon w-9 h-9 rounded-xl flex items-center justify-center
                     flex-shrink-0 transition-all duration-200"
            >
              <i [class]="'bi ' + item.icon + ' text-sm'"></i>
            </div>
            <span *ngIf="!collapsed" class="truncate">{{ item.label }}</span>
          </button>
        </ng-template>

      </ng-container>
    </nav>

    <!-- Footer -->
    <div class="relative border-t border-[var(--color-border)] p-4 flex-shrink-0 z-10">
      <div
        class="sidebar-user-card flex items-center gap-3 rounded-2xl px-3 py-3"
        [class.justify-center]="collapsed"
      >
        <div
          class="w-11 h-11 rounded-2xl bg-[var(--color-secondary)] text-white
                 flex items-center justify-center shadow-sm flex-shrink-0"
        >
          <i class="bi bi-person-fill text-sm"></i>
        </div>
        <div *ngIf="!collapsed" class="flex-1 min-w-0">
          <p class="text-sm font-semibold truncate text-[var(--color-secondary)]">
            {{ getUser()?.firstName }} {{ getUser()?.lastName }}
          </p>
          <p class="text-xs truncate text-[var(--color-muted-foreground)]">
            {{ getRoleLabel() }}
          </p>
        </div>
        <button
          *ngIf="!collapsed"
          (click)="openLogoutModal()"
          class="w-9 h-9 rounded-xl flex items-center justify-center
                 text-[var(--color-muted-foreground)]
                 hover:text-[var(--color-destructive)]
                 hover:bg-red-50
                 transition-all duration-200 flex-shrink-0 cursor-pointer"
          aria-label="Sign out"
        >
          <i class="bi bi-box-arrow-right text-sm"></i>
        </button>
      </div>
      <button
        *ngIf="collapsed"
        (click)="openLogoutModal()"
        class="w-full mt-3 h-10 rounded-xl flex items-center justify-center
               text-[var(--color-muted-foreground)]
               hover:text-[var(--color-destructive)]
               hover:bg-red-50
               transition-all duration-200 cursor-pointer"
        aria-label="Sign out"
      >
        <i class="bi bi-box-arrow-right text-sm"></i>
      </button>
    </div>

  </aside>

  <!-- Logout confirmation modal -->
  <div
    *ngIf="showLogoutModal"
    class="sidebar-modal-backdrop"
    role="dialog"
    aria-modal="true"
    aria-labelledby="logout-modal-title"
    (click)="closeLogoutModal()"
  >
    <div class="sidebar-modal-card" (click)="$event.stopPropagation()">

      <div class="flex items-start gap-4 mb-5">
        <div class="sidebar-modal-icon">
          <i class="bi bi-box-arrow-right text-lg"></i>
        </div>
        <div>
          <h3 id="logout-modal-title" class="text-base font-bold text-[var(--color-foreground)]">
            Sign out?
          </h3>
          <p class="text-sm text-[var(--color-muted-foreground)] mt-1 leading-relaxed">
            You'll need to sign in again to access your dashboard and learning materials.
          </p>
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-end gap-3">
        <button type="button" (click)="closeLogoutModal()" class="sb-btn-secondary">
          Cancel
        </button>
        <button type="button" (click)="confirmLogout()" class="sb-btn-primary">
          <i class="bi bi-box-arrow-right text-sm"></i>
          Sign out
        </button>
      </div>

    </div>
  </div>

</div>
